export default {
basicHtml: `
<ow-scroll style="border: 4px solid red;" :height="400">
    100 <p/> element here.
</ow-scroll>`
}